import React from 'react';
import {connect} from 'react-redux';

import { useMsal } from "@azure/msal-react";

import { history } from '../../../store';

import { CUSTOMER_CREATE_URL } from '../../../constants/api';

import isLoggedIn, {logout, isSA, isGM, isSY, isVP, getMyId, isFinanceUser} from '../../../utils/auth';

import RhinoModal from '../../common/modal/RhinoModal';
import RhinoConfirm from '../../common/confirm/RhinoConfirm';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as messagesActionCreators from '../../../actions/messages';
import * as userActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, messagesActionCreators, userActionCreators);


function handleLogout(instance) {
  logout();
  instance.logoutRedirect().catch(e => {
      console.error(e);
  });
}


export const SignOutButton = () => {
    const { instance } = useMsal();

    return (
        <div className={'menuItem lastItem'} onClick={() => handleLogout(instance)}>Log Out</div>
    );
}


class HeaderMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      passwordModelOpen: false,
      passwordValue: '',

      passwordConfirmOpen: false,
    };
   this.checkClick = this.checkClick.bind(this);
  }

  componentWillMount() {
    document.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkClick, false);
  }

  checkClick(evt) {

    if(evt.clientX < 100 && evt.clientY < 100) {
      return;
    }

    if(this.state.menuOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement === this.menuBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ menuOpen : false });
    }
    
  }

  logoutUser() {
    logout();
    this.props.authClear();
    this.setState({menuOpen: false});
  }

  userNav(page) {
    this.setState({menuOpen: false});
    history.push('/' + page);
  }

  externalNav(url, openNew = false) {
    if(openNew) {
      let win = window.open(url, '_blank');
      win.focus();
    } else {
      window.location.href = url;
    }
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  nullRoute() {
    this.setState({menuOpen: false});
  }

  toggleCostData() {

    if(!this.props.auth.hideData) {
      this.props.authToggleHide();  
    } else {
      this.openPasswordModal();
    }
  }

  closePasswordModal() {
    this.setState({ passwordModelOpen: false });
  }

  changePasswordValue(evt) {
    this.setState({ passwordValue: evt.target.value });
  }

  openPasswordModal() {
    this.setState({ passwordModelOpen: true });
  }

  submitPasswordValidation() {

    if(!this.state.passwordValue) {
      return;
    }

    this.props.userValidatePassword({ password: this.state.passwordValue })
    .then((respData) => {
      this.props.authToggleHide(); 
      this.setState({ 
        passwordError: false,
        passwordValue: '',
        passwordModelOpen: false,
      });
      if(respData.auth.need_password_reset) {
        history.push('/update-password');
      }
    })
    .catch((errData) => {
      this.setState({ passwordError: true });
    });
  }

  togglePasswordConfirm() {
    this.setState({ passwordConfirmOpen: !this.state.passwordConfirmOpen });
  }

  sendPasswordReset() {

    let userData = {
      id: getMyId(),
    }
    
    this.props.usersAdminPasswordReset(userData)
      .then((respData) => {
        this.togglePasswordConfirm();
        this.props.commonAlert('Password reset sent');
      })
      .catch((errorData) => {
        this.setState({
          serverError: errorData.message
        });
      });
  }

  render() {
    return <div className='HeaderMenu'>
      <div className='iconWrapper' onClick={this.toggleMenu.bind(this)}>
        <img src='/img/header/menu.svg' alt='Menu' />
        {this.props.messages.unreadCount && isLoggedIn() ?
          <div className='iconMessageIndicator'>
            <div className='iconMessageNumber'>{this.props.messages.unreadCount}</div>
          </div> :
          null
        }
      </div>
      <div className={this.state.menuOpen ? 'menuWrapper open' : 'menuWrapper closed'} ref={(menuBody) => { this.menuBody = menuBody; }}>
        <div>
          {isLoggedIn() ?
            <div className={isLoggedIn() ? 'menuItem firstItem' : 'menuItem'} onClick={() => {this.userNav('diamonds')}}>Diamond Search</div> :
            null
          }
          {isLoggedIn() ?
            <div className={'menuItem'} onClick={() => {this.userNav('jewelry')}}>Jewelry Search</div> :
            null
          }
          {isLoggedIn() ?
            <div className={'menuItem'} onClick={() => {this.userNav('watches')}}>Timepiece Search</div> :
            null
          }
          {isLoggedIn() ?
            <div className={'menuItem'} onClick={() => {this.userNav('transfer-history')}}>Transfer History</div> :
            null
          }
        </div>
        {false ?
          <div>
            {isLoggedIn() ?
              <div className='menuItem' onClick={() => {this.externalNav(CUSTOMER_CREATE_URL, true)}}>Create Customer</div> :
              null
            }
          </div> :
          null
        }
        <div>
          {isSA() || isGM() || isSY() || isVP() ?
            <div className='menuItem' onClick={() => {this.userNav('leads')}}>Customers</div> :
            null
          }
        </div>
        <div>
          {isLoggedIn() ?
            <div className='menuItem' onClick={() => {this.userNav('finance/calculator')}}>Financing Calculator</div> :
            null
          }
        </div>
        <div>
          {isFinanceUser() ?
            <div className='menuItem' onClick={() => {this.userNav('finance/plans')}}>Manage Finance Plans</div> :
            null
          }
        </div>
        <div>
          {(isSY()) === true ? 
            <div className='menuItem' onClick={() => {this.userNav('manage-users')}}>Manage Users</div> :
            null
          }
        </div>
        <div>
          {isLoggedIn() ?
            <div className={'menuItem'} onClick={() => {this.userNav('messages')}}>Messages &nbsp;
              {this.props.messages.unreadCount ?
                <span className='messageIndicator'>
                  <span className='messageNumber'>{this.props.messages.unreadCount}</span>
                </span> :
                null
              }
            </div> :
            null
          }
        </div>
        <div>
          {isLoggedIn() ?
            <div className={this.props.auth.hideData ? 'menuItem menuItemUnchecked' : 'menuItem menuItemChecked'} onClick={this.toggleCostData.bind(this)}>
              <span className='checkedMarker'><i className="fas fa-check"></i></span>
              <span className='uncheckedMarker'><i className="fas fa-times"></i></span>
              <span>Show Costs?</span>
            </div> :
            null
          }
        </div>
        <div>
          {isLoggedIn() ?
            <SignOutButton /> :
            <>
              <div className={'menuItem lastItem firstItem'} onClick={() => {this.userNav('login')}}>Employee Login</div>
            </>
          }
        </div>
        <div className='menuArrow' onClick={this.nullRoute.bind(this)}>
          <img src='/img/header/arrow_white.svg' alt='' />
        </div>
      </div>
      <RhinoModal
        open={this.state.passwordModelOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closePasswordModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Enter DD App Password to Enable Cost</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' alt='' />
          </div>
          {this.state.passwordError ? 
            <div className='errMessage'>User not validated</div> :
            null
          }
          <div className='transferModalInput'>
            <input
              type='password'
              onChange={this.changePasswordValue.bind(this)}
              value={this.state.passwordValue}
              placeholder='Enter Password' />
          </div>
          <div className='transferModalForgotLinkLine'>
            <span className='transferModalForgotLink' onClick={this.togglePasswordConfirm.bind(this)}>Forgot your DDapp password?</span>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.submitPasswordValidation.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoConfirm
        confirmText='Are you sure you want to reset your password?'
        confirmMethod={this.sendPasswordReset.bind(this)}
        cancelMethod={this.togglePasswordConfirm.bind(this)}
        open={this.state.passwordConfirmOpen} />
    </div>
  }
}
export default HeaderMenu;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    messages: state.messages,
  };
}

export const HeaderMenuContainer = connect(
  mapStateToProps,
  allActionCreators
)(HeaderMenu);